import { useContext } from 'react';
import { FirebaseContext } from './FirebaseContext';

// Auth hook for child components to get the auth object
export const useFirebase = () => useContext(FirebaseContext);
